import { StatePropertyRef } from '../../canvas/ExtendableStore';

export type HandMode = 'public' | 'private' | 'unspecified';
export interface HandInfo {
    enabled: boolean;
    object: string;
}

export const CreateHandInfo = (enabled: boolean, object: string = null) =>
    ({ enabled, object }) as HandInfo;

export const HandInfo = StatePropertyRef<HandInfo>('hand', CreateHandInfo(false));
